import { postGetProductionByIds } from "../request/designapi/design/production/getProductionByIds/post.js";
import { createBatchRequestWithCache } from "./createBatchRequestWithCache.js";
const opGetProductionByIds = createBatchRequestWithCache(postGetProductionByIds, {
  debounceDelay: 50,
  apiName: "designapi/design/production/getProductionByIds\u63A5\u53E3"
});
export { opGetProductionByIds };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/opGetProductionByIds.js